import {Component, OnInit} from '@angular/core';
import {Page} from '../../../../global/util/enum/Page';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AddEditTemplateComponent} from '../add-edit-template/add-edit-template.component';
import {Constant} from '../../../../global/util/Constant';
import {TemplateService} from '../../../service/template.service';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {Dialog} from '../../../../global/util/Dialog';
import {InformType} from '../../../../global/util/enum/InformType';
import {AuthService} from '../../../service/auth/auth.service';
import {ApplicationService} from '../../../service/application.service';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {Template} from '../../../model/Template';
import {Pagination} from '../../../../global/util/Pagination';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-list-template',
  templateUrl: './list-template.component.html',
  styleUrls: ['./list-template.component.css']
})
export class ListTemplateComponent implements OnInit {
  templates: any[] = [];
  public page: any = {};
  public links: any = {};
  private templateUrl: string;
  public enumPage = Page;
  public loading: boolean;
  public entityName = 'TITLE.TEMPLATE';
  public partnerIdSelected = 0;
  public enterpriseIdSelected: number;
  public description = '';
  public startDate = '';
  public endDate = '';
  public showAll = false;
  private title = 'TITLE.TEMPLATE';
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public partners: any[] = [];
  public enterprises: any[] = [];
  public NEW_TEMPLATE = Constant.CREATE_NEW_TEMPLATE;
  public UPLOAD_TEMPLATE = Constant.UPLOAD_TEMPLATE;
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(private modalService: NgbModal,
              private templateService: TemplateService,
              public authenticationService: AuthService,
              public applicationService: ApplicationService,
              public enterpriseService: EnterpriseService,
              public enterpriseDataService: EnterpriseDataService,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.setDefaultData();
  }

  // tslint:disable-next-line:variable-name
  openAddModal(templateType?: string) {
    const newTemplate = new Template();
    newTemplate.type = templateType;
    const openModal = this.modalService.open(AddEditTemplateComponent, {
      backdrop: 'static',
      size: templateType === Constant.CREATE_NEW_TEMPLATE ? 'xl' : 'lg'
    });
    openModal.componentInstance.template = newTemplate;
    openModal.componentInstance.designTemplate = templateType === Constant.CREATE_NEW_TEMPLATE;
    openModal.result.then(success => {
      if (InformType.Success === success) {
        Dialog.show(InformType.Success, this.title);
        this.loadTemplates(Page.First);
      }
    });
  }

  loadTemplates(page: Page) {
    switch (page) {
      case Page.First:
        this.templateUrl = Constant.ROOT_API_V1
          .concat('/templates/')
          .concat('?partnerId=')
          .concat(String(this.partnerIdSelected))
          .concat('&enterpriseId=')
          .concat(String(this.enterpriseIdSelected))
          .concat('&description=')
          .concat(String(this.description))
          .concat('&startDate=')
          .concat(String(this.startDate))
          .concat('&endDate=')
          .concat(String(this.endDate))
          .concat('&showAll=')
          .concat(String(this.showAll))
          .concat('&size=')
          .concat(this.pageNumber)
          .concat('&sort=id,desc');
        break;
      case Page.Previous:
        this.templateUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.templateUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.templateUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.templateUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getTemplates(this.templateUrl);

  }

  getTemplates(templateUrl: string) {
    this.loading = true;
    this.templateService.get(templateUrl).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.templates = next._embedded.template;
      } else {
        this.templates = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      this.entityName = this.translate.instant('TITLE.TEMPLATE');
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.entityName, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  openEditModal(template: any) {
    const templateCopy = Object.assign({}, template);
    const openModal = this.modalService.open(AddEditTemplateComponent, {
      backdrop: 'static',
      size: templateCopy.type === Constant.CREATE_NEW_TEMPLATE ? 'xl' : 'lg'
    });
    if (templateCopy.type === Constant.CREATE_NEW_TEMPLATE) {
      openModal.componentInstance.designTemplate = true;
    }
    openModal.componentInstance.partners = this.partners;
    openModal.componentInstance.enterprises = this.partners;
    openModal.componentInstance.template = templateCopy;
    openModal.result.then(success => {
      if (InformType.Success === success) {
        Dialog.show(InformType.Success, this.title);
        this.loadTemplates(Page.Self);
      }
    });
  }

  openDeleteModal(template: any) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-TEMPLATE');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-TEMPLATE');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteTemplate(template);
      }
    });
  }

  private deleteTemplate(template: any) {
    this.loading = true;
    this.templateService.delete(template.id).subscribe(() => {
      this.loading = false;
      this.loadTemplates(Page.Self);
      Dialog.show(InformType.Success, this.entityName);
    }, error => {
      this.loading = false;
      this.processError(this.title, error);
    });
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private setDefaultData() {
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.enterpriseIdSelected = this.enterprises[Constant.ZERO_INDEX].id;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartnersExtra();
      this.partnerIdSelected = this.partners[Constant.ZERO_INDEX].id;
      this.getAllEnterprisesBy();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      const partnerId = LocalStorage.getPartnerId();
      this.partnerIdSelected = partnerId;
      this.getEnterprisesByPartner(partnerId);
    } else {
      this.partnerIdSelected = LocalStorage.getPartnerId();
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
    }
    this.loadTemplates(Page.First);
  }

  reloadTemplate0() {
    this.getEnterpriseBy(this.partnerIdSelected);
  }

  reloadTemplate1() {
    this.templates = [];
    // this.getEnterprisesByPartner(this.partnerIdSelected);
    this.reloadTemplates();
  }

  hasRole(roleDescription: any) {
    return this.authenticationService.hasRole(roleDescription);
  }

  reloadTemplates() {
    this.loadTemplates(Page.First);
  }

  search() {
    this.reloadTemplates();
  }

  onlyShowAll(event: any) {
    this.showAll = event.target.checked;
    this.reloadTemplates();
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      const enterpriseFilter = enterprises.filter(value => value.partnerId === this.partnerIdSelected);
      this.enterprises = LocalStorage.addEnterprise(enterpriseFilter).sort();
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      if (this.enterprises.length > 0) {
        this.enterpriseIdSelected = this.enterprises[Constant.ZERO_INDEX].id;
      }
    });
  }

  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterprises = enterprises.sort();
      this.enterpriseDataService.setEnterprises(this.enterprises);
      if (this.enterprises.length > 0) {
        this.enterpriseIdSelected = this.enterprises[Constant.ZERO_INDEX].id;
      }
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param id
   * @private
   */
  private getEnterpriseBy(id: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (id === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => id === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.reloadTemplates();
    }
  }
}
